import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCompanyByUserLogin,
  fetchUsersAcessCompanyByCompanyId,
} from "../../service/api";

const initialState = {
  companies: [],
  company: {
    selectedTab: "Info",
    info: {},
    documents: [],
    history: [],
    users: [],
    isNewUserModalOpen: false,
  },
};

export const fetchCompanyByUserLogin = createAsyncThunk(
  "companies/getCompanyById",
  async (num) => {
    const { data } = await getCompanyByUserLogin(num);
    return data;
  }
);

export const fetchCompanyUsers = createAsyncThunk(
  "companies/getUsers",
  async (num) => {
    const { data } = await fetchUsersAcessCompanyByCompanyId(num);
    return data;
  }
);

export const companiesSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    setCompanyInfo: (state, action) => {
      state.company.info = action.payload;
    },
    setCompanyHistory: (state, action) => {
      state.company.history = action.payload;
    },
    setCompanySelectedTab: (state, action) => {
      state.company.selectedTab = action.payload;
    },
    setIsNewUserModalOpen: (state, action) => {
      state.company.isNewUserModalOpen = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyByUserLogin.fulfilled, (state, action) => {
        state.company.info = action.payload;
      })
      .addCase(fetchCompanyUsers.fulfilled, (state, action) => {
        state.company.users = action.payload;
      });
  },
});

export const {
  setCompanyInfo,
  setCompanyHistory,
  setCompanies,
  setCompanySelectedTab,
  setIsNewUserModalOpen,
} = companiesSlice.actions;

export default companiesSlice.reducer;
